import { V2L2SmallModalRoot } from '../V2L2ModalRoot'
import { V2L2ModalTitlebar, V2L1ModalDismissButton } from '../V2ModalTitlebar'
import { V2L1ModalDetailLabel, V2L2ModalContent, V2L2ModalDetailRoot } from '../V2ModalContent'
import { V2L2ModalActionbar } from '../V2L2ModalActionbar'
import { V2L1ReasonableButton } from '../../Button/V2L1ReasonableButton'
import L1TextField from '../../../form/l1/L1TextField'
import { ComplexElementSize } from '../../../form/ComplexElementSize'
import { faLink } from '@fortawesome/pro-regular-svg-icons'
import { L1ClipboardCopyButton, useClipboardCopy } from '../../../interface/L1ClipboardCopyButton'
import L2ControlGrid from '../../../form/l2/L2ControlGrid'
import L2ControlGridLayout from '../../../form/l2/L2ControlGridLayout'

export interface V2L3GenerateMeetingLinksModalPropsLinks {
	// dan says: do not display member
	// Dan says now show the member link 9/23/2026
	// both forms of it: memberJoinUrl is the same url as memberLongLinkURL,
	// shortened through fadv.link
	memberJoinUrl: string
	memberLongLinkURL: string
	interpreterJoinUrl: string
	incognitoJoinUrl: string
	otherJoinUrl: string 
}

interface V2L3GenerateMeetingLinksModalProps {
	loading: boolean
	value: string
	links: V2L3GenerateMeetingLinksModalPropsLinks|null
	onChange?: React.ChangeEventHandler<HTMLInputElement>
	onSubmit?: React.MouseEventHandler<HTMLButtonElement>
	onDismissClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L3GenerateMeetingLinksModal = ({loading, value, links, onChange, onSubmit, onDismissClick}: V2L3GenerateMeetingLinksModalProps) => {
	const memberShortCopy = useClipboardCopy(links?.memberJoinUrl ?? null)
	const memberLongCopy = useClipboardCopy(links?.memberLongLinkURL ?? null)
	const interpreterCopy = useClipboardCopy(links?.interpreterJoinUrl ?? null)
	const otherCopy = useClipboardCopy(links?.otherJoinUrl ?? null)
	const incongitoCopy = useClipboardCopy(links?.incognitoJoinUrl ?? null)
	return (
		<V2L2SmallModalRoot>
			<V2L2ModalTitlebar
				title="Generate Meeting Links"
				buttons={<V2L1ModalDismissButton onClick={onDismissClick} />}
			/>
			<V2L2ModalContent>
				{links ? (
					<V2L2ModalDetailRoot>
						<V2L1ModalDetailLabel>Links</V2L1ModalDetailLabel>
						<L2ControlGrid layout={L2ControlGridLayout.FlowRow} columnCount={2}>
							<L1ClipboardCopyButton showSuccess={memberShortCopy.showSuccess} onClick={memberShortCopy.handleClick} /> Member Short Link
							<L1ClipboardCopyButton showSuccess={memberLongCopy.showSuccess} onClick={memberLongCopy.handleClick} /> Member Long Link
						<L1ClipboardCopyButton showSuccess={interpreterCopy.showSuccess} onClick={interpreterCopy.handleClick} /> Interpreter Join URL
							<L1ClipboardCopyButton showSuccess={otherCopy.showSuccess} onClick={otherCopy.handleClick} /> Other Join URL
							<L1ClipboardCopyButton showSuccess={incongitoCopy.showSuccess} onClick={incongitoCopy.handleClick} /> Incognito Join URL
						</L2ControlGrid>
					</V2L2ModalDetailRoot>
				) : (
					<V2L2ModalDetailRoot>
						<V2L1ModalDetailLabel>Member GUID</V2L1ModalDetailLabel>
						<L1TextField
							size={ComplexElementSize.FlexStretch}
							value={value}
							onChange={onChange}
							disabled={loading}
						/>
					</V2L2ModalDetailRoot>
				)}
			</V2L2ModalContent>
			{links ? null : (
				<V2L2ModalActionbar>
					<V2L1ReasonableButton
						icon={faLink}
						label="Generate"
						onClick={onSubmit}
						loading={loading}
					/>
				</V2L2ModalActionbar>
			)}
		</V2L2SmallModalRoot>
	)
}
